import type { PropsWithChildren } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';
import { TrackingContext } from '@change-corgi/core-react/tracking';

type Props = PropsWithChildren<{ version?: number }>;

export const TrackingShell: React.FC<Props> = ({ children, version }) => {
	const { token } = useKnownAvailableParams<{ token: string }>();
	const properties = version === undefined ? { angle_token: token } : { angle_token: token, version };

	return <TrackingContext properties={properties}>{children}</TrackingContext>;
};
